var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2233 0.0215001L0.453911 6.21003C0.211534 6.27602 0.0334016 6.48219 0.00419952 6.73158C-0.0250025 6.98097 0.0999822 7.22334 0.320166 7.34366L10.8814 13.1187L16.6558 23.6799C16.7644 23.8791 16.9723 24 17.1954 24C17.2194 24 17.2433 23.9988 17.2679 23.9959C17.5173 23.9667 17.724 23.7886 17.7894 23.5462L23.9785 0.776669C24.0363 0.563493 23.9756 0.3363 23.8196 0.18036C23.6637 0.0244203 23.4359 -0.0363202 23.2233 0.0215001ZM2.25159 6.99732L21.3135 1.81568L11.2254 11.9039L2.25159 6.99732ZM17.0033 21.7491L12.0962 12.7747L22.1837 2.68649L17.0027 21.7485L17.0033 21.7491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.0d11ce251abf85fb69f1fc2ae272289a.svg";
export { ForwardRef as ReactComponent };